import { React, styled } from '../lib/imports';
import { useSelector } from 'react-redux';
import { useCdnUrl } from '../app/context/config';
import { Text, CloseApp } from '../components';

const GetNewAppContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.darkBg};
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderLogoContainer = styled.div`
  display: flex;
  margin-left: 31px;
`;

const Header1 = styled.h1`
  font-size: ${({ theme }) => theme.typography.subHeadings.tera.fontSize};
  line-height: 35px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: white;
  margin: unset;
`;

const Header2 = styled.h1`
  font-size: ${({ theme }) => theme.typography.subHeadings.tera.fontSize};
  line-height: 35px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: white;
  margin: unset;
  margin-left: 31px;
`;

const TimsLogo = styled.img`
  height: 30px;
  max-width: 100%;
  object-fit: contain;
  margin-left: ${({ theme }) => theme.spacings.byte};
`;

const Description = styled(Text)`
  color: white;
  text-align: center;
  font-size: ${({ theme }) => theme.typography.text.tera.fontSize};
  line-height: 18px;
  margin: 30px 60px 0px 60px;
`;

const StoreLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 49px;
`;

const StoreLogo = styled.img`
  height: ${({ theme }) => theme.spacings.exa};
  max-width: 100%;
  object-fit: contain;
`;

const CloseContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1000;
`;

const GetNewApp = () => {
  const { strings } = useSelector((state) => state);
  const cdnUrl = useCdnUrl();

  const timsLogoSrc = `${cdnUrl}${strings['getNewApp/timsLogo']}`;
  const googleStoreLogoSrc = `${cdnUrl}${strings['getNewApp/googleLogo']}`;
  const appleStoreLogoSrc = `${cdnUrl}${strings['getNewApp/appleLogo']}`;

  const header1 = strings['getNewApp/header1'];
  const header2 = strings['getNewApp/header2'];
  const text = strings['getNewApp/text'];
  const appleStoreLink = strings['getNewApp/appleLink'];
  const googleStoreLink = strings['getNewApp/googleLink'];

  return (
    <GetNewAppContainer>
      <CloseContainer>
        <CloseApp href='timhortons:///' />
      </CloseContainer>
      <HeaderContainer>
        <HeaderLogoContainer>
          <Header1>{header1}</Header1>
          <TimsLogo src={timsLogoSrc} />
        </HeaderLogoContainer>
        <Header2>{header2}</Header2>
      </HeaderContainer>
      <Description>{text}</Description>
      <StoreLogoContainer>
        <a href={appleStoreLink} target='_parent' rel='noopener noreferrer'>
          <StoreLogo src={appleStoreLogoSrc} />
        </a>
        <a href={googleStoreLink} target='_parent' rel='noopener noreferrer'>
          <StoreLogo style={{ marginLeft: '16px' }} src={googleStoreLogoSrc} />
        </a>
      </StoreLogoContainer>
    </GetNewAppContainer>
  );
};

export default GetNewApp;
